import { writable, derived } from 'svelte/store';
export const storePodcasts = writable([]);
export const storePodcastCategoryPortrait = derived(storePodcasts, $storePodcasts => $storePodcasts.filter((podcast) => podcast.podcast_category == 1));
export const storePodcastCategoryLecture = derived(storePodcasts, $storePodcasts => $storePodcasts.filter((podcast) => podcast.podcast_category == 2));
export const storePodcastCategoryReportage = derived(storePodcasts, $storePodcasts => $storePodcasts.filter((podcast) => podcast.podcast_category == 3));
export const storePodcastCategory = writable("0");
export const storePodcast = writable({});
export const storePodcastPlayer = writable({});
export const emptyPodcast = {
    id: 0,
    title: "",
    subtitle: "",
    photo_file_name: "",
    text: "",
    podcast_category: 0,
    date: "",
    spotify: "",
    podcast_file_name: "",
};
